export function assertIsDefined<T>(value: any): asserts value is NonNullable<T> {
  if (value === undefined || value === null) {
    throw new Error(`Expected to be defined but received ${JSON.stringify(value)}`);
  }
};